import React from 'react';
import * as FiIcons from 'react-icons/fi';

export default function SafeIcon({ icon, name, ...props }) {
  const IconComponent = icon || (name && FiIcons[`Fi${name}`]);
  return IconComponent ? React.createElement(IconComponent, props) : null;
}